import React from 'react';
import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';

import { i18n } from '../../widgetMacroI18n.ts';
import type { EmbedDescriptor } from '../../widgetMacroTypes.ts';

const styles = cssMap({
	root: {
		border: 'none',
		marginBlockStart: token('space.150'),
		marginBlockEnd: token('space.150'),
	},
});

type Props = {
	descriptor: EmbedDescriptor;
};

/**
 * Renders an iframe with `allowFullScreen` for video providers such as Vimeo.
 */
export const FullscreenIframeEmbed = ({ descriptor }: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const title = formatMessage(i18n.embedTitle, { provider: descriptor.provider });

	return (
		<Box xcss={styles.root} testId="widget-macro-fullscreen-iframe">
			<iframe
				title={title}
				src={descriptor.embedUrl}
				width={descriptor.width || undefined}
				height={descriptor.height || undefined}
				frameBorder={0}
				allowTransparency
				allowFullScreen
			/>
		</Box>
	);
};
